export { default } from './DocumentRename'